import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: { // vuex中储存的数据全部存在这
    isLogin: false, // 登陆是否成功
    LoginShow:false
  },
  getters: { // 通过getters方法调用vuex中数据的方法放在这
    getLineDeviceList: state => {
      return state.isLogin;
    }
  },
  mutations: { // 修改vuex中数据的方法放在这
    LoginFun (state, num) {
        state.LoginShow = num;
      },
  	updateIsLogin (state, num) {
      state.isLogin = num;
    },
    updateIsLoginObject (state, payload) {
      state.isLogin = payload.isLogin;
    },
	setIsLoginTrue (state) {
      state.isLogin = true;
    },
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/stroe/index.js